module.exports = __webpack_public_path__ + "static/images/spike04.d888872.png";